import { InjectionToken } from '@angular/core';
import { Report } from '../../documents';

export const HIDE_DIALOG_DATA_TOKEN = new InjectionToken('HIDE_DIALOG_DATA');

export interface HideDocumentDialogData {
    report: Report;
}
